import React from "react";
import AuthContext from "../store/AuthContext";
import SettingsService from "../services/SettingsService"

const DimensionIcon: React.FC<{dimId: string}> = (props) => {
    const authCtx = React.useContext(AuthContext);
    return (
        <img src={authCtx.makeFileUrl(props.dimId, 'icon.png')}
            style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '12px'
            }}
            onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src="/img/dimension.png";
            }}
        />
    );
};

export default DimensionIcon;
